<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">香港专才计划移居</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>
        “香港专才计划”即“输入内地人才计划”，本计划旨在吸引一些具有认可资历的内地优秀人才和专业人才来港工作，以满足本港人才的需要，提高香港在国际市场的竞争力。申请本计划的内地人才须拥有本港缺乏或无法即时提供的专业知识和技能。该计划无配额限制，亦不限行业。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/hk/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1.具备良好的教育背景或经验、成就</p>
            <p>2.申请前已获聘用，从事的工作须与其学历或工作经验有关</p>
            <p>3.薪酬福利与当时香港市场大致相同</p>

          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/hk/2.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、无需投资</p>
            <p>2、申请流程快，1-3个月即可获批</p>
            <p>3、配偶及18岁以下子女一同来港，小孩可以在香港享受教育、医疗福利</p>
            <p>4、可以合法在香港生小孩，在香港出生的子女即可拥有香港护照</p>
            <p>5、居住满7年后可申请成为香港永久居民</p>
            <p>6、香港护照免签164个国家和地区</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/hk/4.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、咨询及评估</p>
            <p>2、与嘉诚海外签订服务合同</p>
            <p>3、匹配雇主</p>
            <p>4、准备申请文件</p>
            <p>5、递交申请文件</p>
            <p>6、获入境签证</p>
            <p>7、入境香港</p>
            <p>8、办理香港居民身份证</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
export default {
  name: 'Hk'
}
</script>

<style scoped>

</style>
